var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMedical(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    enableBackground: "new 0 0 45 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M13.8,13.9h17.5V9.6h-3.1v0.8c0,0.3-0.2,0.5-0.5,0.5H17.2c-0.3,0-0.5-0.2-0.5-0.5V9.6h-3V13.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M12.8,13.9H8.3c-1.4,0-2.6,1.2-2.6,2.6v18.2c0,1.4,1.2,2.6,2.6,2.6h28.3c1.4,0,2.6-1.2,2.6-2.6V16.6 c0-1.4-1.2-2.6-2.6-2.6h-4.4V9.1c0-0.3-0.2-0.5-0.5-0.5h-3.6V8.1c0-0.3-0.2-0.5-0.5-0.5H17.2c-0.3,0-0.5,0.2-0.5,0.5v0.4h-3.5 c-0.3,0-0.5,0.2-0.5,0.5V13.9z M36.7,14.9c0.9,0,1.6,0.7,1.6,1.6v18.2c0,0.9-0.7,1.6-1.6,1.6H8.3c-0.9,0-1.6-0.7-1.6-1.6V16.6 c0-0.9,0.7-1.6,1.6-1.6H36.7z M16.8,9.6v0.8c0,0.3,0.2,0.5,0.5,0.5h10.4c0.3,0,0.5-0.2,0.5-0.5V9.6h3.1v4.4H13.8V9.6H16.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9F9F9",
    d: "M8.3,14.9c-0.9,0-1.6,0.7-1.6,1.6v18.2c0,0.9,0.7,1.6,1.6,1.6h28.3c0.9,0,1.6-0.7,1.6-1.6V16.6 c0-0.9-0.7-1.6-1.6-1.6H8.3z M31,25.6c0,4.7-3.8,8.5-8.5,8.5c-4.7,0-8.5-3.8-8.5-8.5c0-4.7,3.8-8.5,8.5-8.5 C27.2,17.1,31,20.9,31,25.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M14,25.6c0,4.7,3.8,8.5,8.5,8.5c4.7,0,8.5-3.8,8.5-8.5c0-4.7-3.8-8.5-8.5-8.5C17.8,17.1,14,20.9,14,25.6z  M30,25.6c0,4.2-3.4,7.6-7.6,7.6c-4.2,0-7.6-3.4-7.6-7.6c0-4.2,3.4-7.6,7.6-7.6C26.6,18.1,30,21.5,30,25.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9F9F9",
    d: "M14.8,25.6c0,4.2,3.4,7.6,7.6,7.6c4.2,0,7.6-3.4,7.6-7.6c0-4.2-3.4-7.6-7.6-7.6 C18.3,18.1,14.8,21.5,14.8,25.6z M24.3,20.9v2.9h2.8c0.3,0,0.5,0.2,0.5,0.5v2.7c0,0.3-0.2,0.5-0.5,0.5h-2.8v2.8 c0,0.3-0.2,0.5-0.5,0.5h-2.7c-0.3,0-0.5-0.2-0.5-0.5v-2.8h-2.9c-0.3,0-0.5-0.2-0.5-0.5v-2.7c0-0.3,0.2-0.5,0.5-0.5h2.9v-2.9 c0-0.3,0.2-0.5,0.5-0.5h2.7C24.1,20.4,24.3,20.7,24.3,20.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2724A",
    d: "M20.7,20.9v2.9h-2.9c-0.3,0-0.5,0.2-0.5,0.5v2.7c0,0.3,0.2,0.5,0.5,0.5h2.9v2.8c0,0.3,0.2,0.5,0.5,0.5h2.7 c0.3,0,0.5-0.2,0.5-0.5v-2.8h2.8c0.3,0,0.5-0.2,0.5-0.5v-2.7c0-0.3-0.2-0.5-0.5-0.5h-2.8v-2.9c0-0.3-0.2-0.5-0.5-0.5h-2.7 C20.9,20.4,20.7,20.7,20.7,20.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedical);
export default __webpack_public_path__ + "static/media/medical.bc748f691a56896262af0896d25e10ca.svg";
export { ForwardRef as ReactComponent };